import VuiBox from "components/VuiBox";
import colors from "assets/theme/base/colors";

const { light } = colors;

const shimmer = {
  background: `
    linear-gradient(
      90deg,
      ${light.secondary} 0%,
      ${light.main} 20%,
      ${light.secondary} 40%,
      ${light.main} 60%,
      ${light.secondary} 80%
    )
  `,
  backgroundSize: "250% 100%",
  animation: "shimmer 2s ease-in-out infinite",
};

const shimmerKeyframes = {
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-100% 0" },
    "100%": { backgroundPosition: "100% 0" },
  },
};

export const SkeletonLine = ({ w = "100%", h = 12, mb = 0.6 }) => (
  <VuiBox width={w} height={h} mb={mb} sx={{ ...shimmer, borderRadius: "6px" }} />
);

const CardSkeleton = ({
  lines = 3,
  hasHeader = true,
  hasFooter = true,
  hasAvatar = false,
  hasChips = false,
}) => {
  return (
    <VuiBox
      p={2.5}
      borderRadius="xl"
      sx={{
        background: light.main,
        border: `1px solid ${light.secondary}`,
        ...shimmerKeyframes,
      }}
    >
      {hasHeader && (
        <VuiBox display="flex" justifyContent="space-between" mb={1}>
          <SkeletonLine w="40%" h={14} />
          <SkeletonLine w="25%" h={18} />
        </VuiBox>
      )}

      {hasAvatar && (
        <VuiBox display="flex" alignItems="center" gap={1} mb={1}>
          <SkeletonLine w="32px" h="32px" />
          <SkeletonLine w="40%" />
        </VuiBox>
      )}

      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonLine key={i} w={i === lines - 1 ? "70%" : "100%"} />
      ))}

      {hasChips && (
        <VuiBox display="flex" gap={1} mt={1}>
          <SkeletonLine w="60px" h={22} />
          <SkeletonLine w="60px" h={22} />
          <SkeletonLine w="60px" h={22} />
        </VuiBox>
      )}

      {hasFooter && (
        <VuiBox mt={2}>
          <SkeletonLine w="100%" h={34} />
        </VuiBox>
      )}
    </VuiBox>
  );
};

export default CardSkeleton;
